import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { cancelCustomerOrder, getCustomerOrder, getCustomerOrders } from '../api';

export const customerOrdersKey = ['customer-orders'];

export function useCustomerOrders(enabled = true) {
  return useQuery({
    queryKey: customerOrdersKey,
    queryFn: async () => (await getCustomerOrders()).data,
    enabled,
  });
}

export function useCustomerOrder(orderId, fallbackOrder) {
  return useQuery({
    queryKey: [...customerOrdersKey, orderId],
    queryFn: async () => {
      const data = (await getCustomerOrder(orderId)).data;
      // During the legacy-to-canonical transition this URL may still return the list.
      if (Array.isArray(data)) {
        return data.find((order) => String(order.customerOrderId || order.id) === String(orderId)) || fallbackOrder;
      }
      return data;
    },
    enabled: Boolean(orderId),
    initialData: fallbackOrder,
  });
}

export function useCancelCustomerOrder() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (orderId) => cancelCustomerOrder(orderId),
    onSuccess: (_data, orderId) => {
      queryClient.invalidateQueries({ queryKey: customerOrdersKey });
      queryClient.invalidateQueries({ queryKey: [...customerOrdersKey, orderId] });
    },
  });
}
